export enum GENDERS {
  MALE = 'Man',
  FEMALE = 'Woman',
  NONBINARY = 'Non-Binary',
  TRANSGENDER = 'Transgender'
}

// unfortunately these need to be kept in sync with GENDERS manually
// due to typescript enum limitations
export enum GENDER_REQUIREMENTS {
  MALE = 'Male',
  FEMALE = 'Female',
  ANY = 'Any',
}

export enum PRONOUNS {
  HE = "He/Him",
  SHE = "She/Her",
  THEY = "They/Them"
}

export enum ACCENTS {
  AFRICAN = 'African',
  AFRIKAANS = 'Afrikaans',
  ALBANIAN = 'Albanian',
  AMERICAN = 'American',
  AMHARIC = 'Amharic',
  ARABIC = 'Arabic',
  ARMENIAN = 'Armenian',
  AUSTRALIAN = 'Australian',
  BASQUE = 'Basque',
  BELARUSIAN = 'Belarusian',
  BENGALI = 'Bengali',
  BOSNIAN = 'Bosnian',
  BRITISH = 'British',
  BULGARIAN = 'Bulgarian',
  BURMESE = 'Burmese',
  CANADIAN = 'Canadian',
  CARIBBEAN = 'Caribbean',
  CATALAN = 'Catalan',
  CEBUANO = 'Cebuano',
  CHINESE = 'Chinese',
  CROATIAN = 'Croatian',
  CZECH = 'Czech',
  DANISH = 'Danish',
  DARI = 'Dari',
  DUTCH = 'Dutch',
  ESPERANTO = 'Esperanto',
  ESTONIAN = 'Estonian',
  FARSI = 'Farsi',
  FILIPINO = 'Filipino',
  FINNISH = 'Finnish',
  FLEMISH = 'Flemish',
  FRENCH = 'French',
  FRISIAN = 'Frisian',
  GALICIAN = 'Galician',
  GEORGIAN_KART = 'Georgian (Kartvelian)',
  GERMAN = 'German',
  GREEK = 'Greek',
  GUJARATI = 'Gujarati',
  GUYANESE_CRE = 'Guyanese Creole',
  HAITIAN_CRE = 'Haitian Creole',
  HARYANVI = 'Haryanvi',
  HAUSA = 'Hausa',
  HEBREW = 'Hebrew',
  HINDI = 'Hindi',
  HUNGARIAN = 'Hungarian',
  ICELANDIC = 'Icelandic',
  IGBO = 'Igbo',
  INDIAN = 'Indian',
  INDONESIAN = 'Indonesian',
  IRISH = 'Irish',
  ITALIAN = 'Italian',
  JAPANESE = 'Japanese',
  JAVANESE = 'Javanese',
  KANNADA = 'Kannada',
  KAZAKH = 'Kazakh',
  KHMER = 'Khmer',
  KOREAN = 'Korean',
  KURDISH = 'Kurdish',
  LAO = 'Lao',
  LATVIAN = 'Latvian',
  LIBERIAN_KRE = 'Liberian Kreyol',
  LITHUANIAN = 'Lithuanian',
  LUXEMBOURGISH = 'Luxembourgish',
  MACEDONIAN = 'Macedonian',
  MALAY = 'Malay',
  MALAYALAM = 'Malayalam',
  MALTESE = 'Maltese',
  MAORI = 'Maori',
  MARATHI = 'Marathi',
  NEPALI = 'Nepali',
  NEW_ZEALAND = 'New Zealand',
  NORWEGIAN = 'Norwegian',
  ODIA = 'Odia',
  ORIYA = 'Oriya',
  OTHER = 'Other',
  PASHTO = 'Pashto',
  POLISH = 'Polish',
  PORTUGUESE = 'Portuguese',
  PUNJABI = 'Punjabi',
  RAJASTHANI = 'Rajasthani',
  ROMANIAN = 'Romanian',
  ROMANSH = 'Romansh',
  RUSSIAN = 'Russian',
  SCOTTISH = 'Scottish',
  SCOTTISH_GAEL = 'Scottish Gaelic',
  SERBIAN = 'Serbian',
  SHONA = 'Shona',
  SICILIAN = 'Sicilian',
  SINDHI = 'Sindhi',
  SINHALESE = 'Sinhalese',
  SLOVAKIAN = 'Slovakian',
  SLOVENIAN = 'Slovenian',
  SOMALI = 'Somali',
  SOUTH_AFR = 'South African',
  SPANISH = 'Spanish',
  SWAHILI = 'Swahili',
  SWEDISH = 'Swedish',
  TAGALOG = 'Tagalog',
  TAIWANESE = 'Taiwanese',
  TAMIL = 'Tamil',
  TELUGU = 'Telugu',
  THAI = 'Thai',
  TURKISH = 'Turkish',
  TURKMEN = 'Turkmen',
  UKRAINIAN = 'Ukrainian',
  URDU = 'Urdu',
  UYGHUR = 'Uyghur',
  UZBEK = 'Uzbek',
  VIETNAMESE = 'Vietnamese',
  WALLOON = 'Walloon',
  WELSH = 'Welsh',
  XHOSA = 'Xhosa',
  YORUBA = 'Yoruba',
  ZULU = 'Zulu',
}

export enum ETHNICITIES {
  AMERICAN_NATIVE = 'American Indian or Alaskan Native Ancestry',
  ASIAN = 'Asian Ancestry',
  AFRICAN_AMERICAN = 'African Ancestry',
  HISPANIC = 'Hispanic or Latin American Ancestry',
  MENA = 'Middle Eastern Ancestry',
  ISLANDER = 'Native Hawaiian or Other Pacific Island Ancestry',
  WHITE = 'European Ancestry',
}

export enum GENRES {
  FICTION = 'Fiction',
  NON_FICTION = 'Non-Fiction',
  KIDS = 'Kids',
  YOUNG_ADULT = 'Young Adult',
  BIOGRAPHY_MEMOIR = 'Biography/Memoir',
  BUSINESS = 'Business',
  COMEDY = 'Comedy',
  FANTASY = 'Fantasy',
  HEALTH_FITNESS = 'Health & Fitness',
  HISTORY = 'History',
  HORROR = 'Horror',
  LIT_FICTION = 'Literary Fiction',
  MYSTERIES_THRILLERS = 'Mysteries & Thrillers',
  RELIGION_SPIRITUALITY = 'Religion & Spirituality',
  ROMANCE = 'Romance',
  SCIENCE_TECHNOLOGY = 'Science & Technology',
  SCI_FI = 'Sci-Fi',
  SELF_DEVELOPMENT = 'Self-Development',
  SPORTS = 'Sports',
  TRAVEL = 'Travel',
  ACTION = 'Action',
  ADVENTURE = 'Adventure',
  FIGHTING = 'Fighting',
  PUZZLE = 'Puzzle',
  RACING = 'Racing',
  ROLE_PLAYING = 'Role-playing',
  SHOOTER = 'Shooter',
  SIMULATION = 'Simulation',
  STRATEGY = 'Strategy',
  MISC = 'Misc'
}

export enum LANGUAGES {
  ENGLISH = 'English',
  ENGLISH_US = 'English (American)',
  ENGLISH_UK = 'English (British)',
  ENGLISH_CA = 'English (Canadian)',
  ENGLISH_CAR = 'English (Caribbean)',
  ENGLISH_IN = 'English (Indian)',
  ENGLISH_IR = 'English (Irish)',
  ENGLISH_SCO = 'English (Scottish)',
  ENGLISH_WLS = 'English (Welsh)',
  ENGLISH_SA = 'English (South African)',
  ENGLISH_AU = 'English (Australian)',
  ENGLISH_NZ = 'English (New Zealand)',
  ENGLISH_AF = 'English (African)',
  SPANISH = 'Spanish',
  SPANISH_CAS = 'Spanish (Castilian)',
  SPANISH_CA = 'Spanish (Central American)',
  SPANISH_CAR = 'Spanish (Caribbean)',
  SPANISH_SA = 'Spanish (South American)',
  SPANISH_MEX = 'Spanish (Mexican)',
  AFRIKAANS = 'Afrikaans',
  ZULU = 'Zulu',
  XHOSA = 'Xhosa',
  YORUBA = 'Yoruba',
  HAUSA = 'Hausa',
  IGBO = 'Igbo',
  SHONA = 'Shona',
  ALBANIAN = 'Albanian',
  AMHARIC = 'Amharic',
  ARABIC = 'Arabic',
  ARABIC_MS = 'Arabic (Modern Standard)',
  ARABIC_NA = 'Arabic (North African)',
  ARABIC_MA = 'Arabic (Mauritania)',
  ARABIC_EGY = 'Arabic (Egyptian)',
  ARABIC_LEV = 'Arabic (Levantine)',
  ARABIC_IRQ = 'Arabic (Iraqi)',
  ARABIC_GUL = 'Arabic (Gulf)',
  ARABIC_HEJ = 'Arabic (Hejazi)',
  ARABIC_NAJ = 'Arabic (Najdi)',
  ARABIC_YEM = 'Arabic (Yemeni)',
  ARMENIAN = 'Armenian',
  BASQUE = 'Basque',
  BELARUSIAN = 'Belarusian',
  BOSNIAN = 'Bosnian',
  BULGARIAN = 'Bulgarian',
  BURMESE = 'Burmese',
  CATALAN = 'Catalan',
  CEBUANO = 'Cebuano',
  CHINESE = 'Chinese',
  CHINESE_CN = 'Chinese (Cantonese)',
  CHINESE_MA = 'Chinese (Mandarin)',
  CHINESE_WU = 'Chinese (Wu)',
  CHINESE_GAN = 'Chinese (Gan)',
  CHINESE_XIA = 'Chinese (Xiang)',
  CHINESE_MIN = 'Chinese (Min)',
  CHINESE_HAK = 'Chinese (Hakka)',
  CHINESE_YUE = 'Chinese (Yue)',
  CROATIAN = 'Croatian',
  CZECH = 'Czech',
  DANISH = 'Danish',
  DARI = 'Dari',
  FARSI = 'Farsi',
  DUTCH = 'Dutch',
  ESPERANTO = 'Esperanto',
  ESTONIAN = 'Estonian',
  FILIPINO = 'Filipino',
  FINNISH = 'Finnish',
  FLEMISH = 'Flemish',
  FRENCH = 'French',
  FRENCH_CA = 'French (Canadian)',
  FRENCH_BE = 'French (Belgium)',
  FRENCH_SUI = 'French (Switzerland)',
  FRENCH_AFR = 'French (African)',
  FRENCH_MET = 'French (Metropolitan)',
  GALICIAN = 'Galician',
  GEORGIAN_KART = 'Georgian (Kartvelian)',
  GERMAN = 'German',
  GERMAN_SUI = 'German (Swiss)',
  GREEK = 'Greek',
  GUYANESE_CRE = 'Guyanese Creole',
  HAITIAN_CRE = 'Haitian Creole',
  HEBREW = 'Hebrew',
  HUNGARIAN = 'Hungarian',
  ICELANDIC = 'Icelandic',
  INDIAN = 'Indian',
  HINDI = 'Hindi',
  BENGALI = 'Bengali',
  TELUGU = 'Telugu',
  MARATHI = 'Marathi',
  TAMIL = 'Tamil',
  URDU = 'Urdu',
  KANNADA = 'Kannada',
  GUJARATI = 'Gujarati',
  PUNJABI = 'Punjabi',
  HARYANVI = 'Haryanvi',
  ORIYA = 'Oriya',
  ODIA = 'Odia',
  INDONESIAN = 'Indonesian',
  ITALIAN = 'Italian',
  JAPANESE = 'Japanese',
  JAVANESE = 'Javanese',
  KAZAKH = 'Kazakh',
  KHMER = 'Khmer',
  KOREAN = 'Korean',
  KURDISH = 'Kurdish',
  LAO = 'Lao',
  LATVIAN = 'Latvian',
  LIBERIAN_KRE = 'Liberian Kreyol',
  LITHUANIAN = 'Lithuanian',
  LUXEMBOURGISH = 'Luxembourgish',
  MACEDONIAN = 'Macedonian',
  MALAY = 'Malay',
  MALAYALAM = 'Malayalam',
  MALTESE = 'Maltese',
  MĀORI = 'Māori',
  NEPALI = 'Nepali',
  NORWEGIAN = 'Norwegian',
  OTHER = 'Other',
  PASHTO = 'Pashto',
  POLISH = 'Polish',
  PORTUGUESE = 'Portuguese',
  PORTUGUESE_BRA = 'Portuguese (Brazilian)',
  PORTUGUESE_IBE = 'Portuguese (Iberian)',
  RAJASTHANI = 'Rajasthani',
  ROMANIAN = 'Romanian',
  ROMANSH = 'Romansh',
  RUSSIAN = 'Russian',
  SERBIAN = 'Serbian',
  SICILIAN = 'Sicilian',
  SINDHI = 'Sindhi',
  SINHALESE = 'Sinhalese',
  SLOVAKIAN = 'Slovakian',
  SLOVENIAN = 'Slovenian',
  SOMALI = 'Somali',
  SWAHILI = 'Swahili',
  SWEDISH = 'Swedish',
  TAGALOG = 'Tagalog',
  TAIWANESE = 'Taiwanese',
  THAI = 'Thai',
  TURKISH = 'Turkish',
  UYGHUR = 'Uyghur',
  TURKMEN = 'Turkmen',
  UKRAINIAN = 'Ukrainian',
  UZBEK = 'Uzbek',
  VIETNAMESE = 'Vietnamese',
  WELSH = 'Welsh',
  YIDDISH = 'Yiddish',
  WALLOON = 'Walloon',
  FRISIAN = 'Frisian',
  IRISH = 'Irish',
  SCOTS = 'Scots',
  SCOTTISH_GAEL = 'Scottish Gaelic'
}

export enum VERTICALS {
  AUDIOBOOKS = 'Audiobooks',
  ANIMATION = 'Animation',
  BUSINESS = 'Business',
  COMMERCIAL_VOICEOVER = 'Commercial Voiceover',
  DOCUMENTARIES = 'Documentaries',
  EDUCATIONAL = 'Educational',
  FILM_TELEVISION = 'Film/Television',
  INTERNET_VIDEO = 'Internet Video',
  MOVIE_TRAILERS = 'Movie Trailers',
  PODCASTING = 'Podcasting',
  RADIO = 'Radio',
  TELEPHONE = 'Telephone',
  VIDEOGAMES = 'Video Games',
  VOICE_ASSISTANT = 'Voice Assistant',
}

export enum AUDITION_TYPES {
  OPEN_CALL = 'openCall',
  PRIVATE = 'private',
}

export enum RECORDING_LOCATIONS {
  TALENT_STUDIO = 'talentStudio',
  ON_SITE_STUDIO = 'onSiteStudio',
}

export enum POINTS_OF_VIEW {
  FIRST_PERSON = '1st person',
  SECOND_PERSON = '2nd person',
  THIRD_PERSON = '3rd person',
}

export enum RECORDING_LENGTH_DURATION_TYPES {
  STUDIO_HOURS = 'studioHours',
  DAYS = 'days',
  FINISHED_HOURS = 'finishedHours',
  WORDS = 'words',
  PAGES = 'pages',
}

export enum UNIONS {
  ACTRA = 'ACTRA',
  AEA = 'AEA',
  AFM = 'AFM',
  AGVA = 'AGVA',
  CAEA = 'CAEA',
  Equity = 'Equity',
  FI_CORE = 'Fi-Core',
  NOT_LISTED = 'Not listed',
  SAG_AFTRA = 'SAG-AFTRA',
  WGA = 'WGA',
}

export enum AGENT_NOTIFICATION_OPTIONS {
  NEVER = 'never',
  ALWAYS = 'always',
}

export enum OFFER_STATUSES {
  SENT = 'sent',
  NEGOTIATING = 'negotiating',
  CANCELED = 'canceled',
  DECLINED = 'declined',
  ACCEPTED = 'accepted',
}

export enum USER_TYPES {
  TALENT = 'talent',
  PRODUCER = 'producer',
  AGENT = 'agent',
  MANAGER = 'manager',
}

export enum DEFAULT_MESSAGES {
  AUDITION_SUBMISSION = 'Audition submitted'
}
